export default __webpack_public_path__ + "static/media/banner-mobile-bg-pink-template.df4d1fb3.svg";